<template>
	<div>
		<div class="container container--small pdt-50">
			<div class="t-headline11 font-m mgb-8 pdl-24 pdr-24">{{$t('1663')}}</div>
			<div class="t-body1 t-color-bodyGrayA font-r pdl-24 pdr-24">{{$t('1664')}}</div>
			<div class="mgt-35 pdl-24 pdr-24 position-relative">
				<label
					class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 mgt-5"
					data-mdc-auto-init="MDCTextField" id="searchValueEl">
					<span class="mdc-notched-outline">
						<span class="mdc-notched-outline__leading"></span>
						<span class="mdc-notched-outline__notch">
							<span class="mdc-floating-label" id="my-label-id">{{$t('766')}}</span>
						</span>
						<span class="mdc-notched-outline__trailing"></span>
					</span>
					<input class="mdc-text-field__input t-body6 font-r" type="text"
							v-validate="'required'"
							ref="searchValue"
							id="searchValue"
							name="searchValue"
							maxlength="50"
							@input="fetchStore($event)"
						>
					<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing d-block"
									tabindex="0" role="button" v-if="searchValue" @click="closeButton" @keypress="closeButton">close</i>
					<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing d-block"
									tabindex="0" role="button" v-else @click="searchButton" @keypress="searchButton">search</i>
				</label>
			<div class="store-list mdc-card mgt-8 pdt-8 pdb-8">
				<div v-if="listData.length > 0 && submitState">
					<ul class="mdc-list mdc-list--two-line" role="radiogroup">
						<li class="mdc-list-item pdt-10 pdb-10 flex-grow-1" role="radio" aria-checked="false" v-for="(store, index) in listData" :key="index">
							<span class="mdc-list-item__ripple"></span>
							<span class="mdc-list-item__graphic">
								<div class="mdc-radio mdc--radio__custom mgt--6">
									<input class="mdc-radio__native-control" type="radio"
										name="demo-list-radio-item-group"
										:value="store.id"
										:id="`store${store.id}`"
										v-model="selectedStore"
										>
									<div class="mdc-radio__background">
										<div class="mdc-radio__outer-circle"></div>
										<div class="mdc-radio__inner-circle"></div>
									</div>
								</div>
							</span>
							<label class="mdc-list-item__text pdl-4" :for="`store${store.id}`">
								<span class="mdc-list-item__text">
									<span class="mdc-list-item__primary-text t-body1 font-r t-wrap t-line-h-20">{{store.name}}</span>
									<span class="mdc-list-item__secondary-text t-body3 font-r t-color-bodyGrayA  t-wrap t-line-h-24"  :class="store.address && store.address.length>65? 'pdb-20':''">
											{{store.address}}
										</span>
								</span>
							</label>
						</li>
					</ul>
				</div>
			
				<div class="t-center mgt-29"  v-else-if="!listData.length && submitState">
					<div class="t-subtitle3">
						{{$t('768')}}
						<!-- 검색 결과가 없습니다. -->
					</div>
					<div class="t-color-bodyGrayA t-body3 mgt-8">
						{{$t('769')}}
						<!-- 검색하신 내용을 다시 확인해주세요. -->
					</div>
			 	</div>
				<infinite-loading @infinite="fetchData" :identifier="infiniteId" spinner="spiral">
					<div slot="no-more" class="mgt-16"></div>
					<div slot="no-results" class="mgt-16"></div>
				</infinite-loading>
			</div>
			</div>

			<div class="mgt-50 mgb-50 pdl-24 pdr-24">
				<button class="mdc-button mdc-button--raised bg-mainBtn b-radius4  w-full" :class="selectedStore? 'btn-red t-color-mainBtnText ' : 'bg-disableBtn t-color-disableBtnText disabled'" @click="regist()" @keypress="regist()" :disabled="!selectedStore">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{$t('1666')}}</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
/**
 * 회원가입 - 매장 검색 및 선택 컴포넌트(sign up - store search & select information component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield';
import {MDCRipple} from '@material/ripple';
import joinApi from '@/api/joinApi.js';
import loginApi from '@/api/loginApi.js';
import {mapState, mapMutations} from 'vuex';
import {joinMixin} from '@/mixins/join.js';
import InfiniteLoading from 'vue-infinite-loading';
import memberApi from '@/api/memberApi';

export default {
	components: {
		InfiniteLoading
	},
	data() {
		return {
			searchValue: '',
			selectedStore: '',
			storeList: {},
			submitState: false,
			searchValueTextField: null,
			listData: [],
			currentPage: 1,
			totalPages: 1,
			infiniteId: +new Date(),
		}
	},

	mixins: [joinMixin],

	computed : {
		...mapState('join',{
			join : state => state,
		}),
	},

	created() {
		if (!this.join.responsibility || !this.join.terms.TERMS_OF_SERVICE || !this.join.name.first || !this.join.name.last || !this.join.loginId) {
			this.moveJoin2Intro();
		}
	},

	mounted() {
		this.setMaterialUi();
	},

	methods: {
		// Store 변이 정의(define store mutation)
		...mapMutations('join', ['SET_STORE', 'INIT_JOIN_STORE']),
		setMaterialUi() {
			window.mdc.autoInit();
			const selector = '.mdc-button, .mdc-list, .mdc-list-item, .mdc-card__primary-action, .mdc-chip-set';
			if(document.querySelector('.mdc-text-field')){
					var textField = new MDCTextField(document.querySelector('.mdc-text-field'));
			}
			this.searchValueTextField = new MDCTextField(document.querySelector('#searchValueEl'))
			this.searchValueTextField.useNativeValidation = false
			const buttonRipple = [].map.call(document.querySelectorAll(selector), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},
		fetchStore($event){
			if(typeof $event !== undefined) {
                this.searchValue = $event.target.value
            } else {
                this.searchValue=''
                
            }
			this.initData() 
		},
		initData() {
			this.listData = []
			this.currentPage = 1
			this.totalPages = 1
			this.infiniteId += 1
		},
		fetchData($state) {
			let params = {
				name: this.searchValue,
				page: this.currentPage,
				size: 10
			};
			 if (this.totalPages >= this.currentPage) {
				this.$validator.validateAll().then((resultValid) => {
					this.submitState = true
					if (resultValid) {
						joinApi.searchStore(params).then((response) => {
							// this.$hideLoading();
							let responseData = response.data.data
							this.listData = this.listData.concat(responseData.content)
							this.currentPage++
							this.totalPages = responseData.totalPages

							if (responseData.content.length) {
								$state.loaded();
							}else {
								$state.complete();
							}

							if (this.listData.length > 0) {
								this.isNoData = false;
							} else {
								this.isNoData = true;
							}
							// this.storeList = response.data.data.content
							this.selectedStore = ''
						}).catch((err) => {
							 this.$hideLoading();
						})	
					} else {
						 this.$hideLoading();
						 $state.complete()
					}
				}).catch((err) => {
						this.$hideLoading();
						console.log('err=>',err)   
					})
			}else {
				 this.$hideLoading();
				$state.complete()
			}
		},

    // 회원가입 API 호출(regist member)
    regist() {
      let responseData = null
      if (this.selectedStore) {
        this.$showLoading();
        this.SET_STORE(this.selectedStore);
        let params = this.join;

        joinApi.register(params).then((response) => {
          responseData = response.data.data;
          if (responseData.status.value === 'ACTIVATION') {
            if ((this.join && this.join.socialLink && this.join.socialLink.token != '') && (this.join && this.join.socialLink && this.join.socialLink.type != '')) {
              loginApi.authCheck().then(() => {
                this.$router.push({name: 'Join2CompleteApproved'})
              }).catch((err) => {
                console.log('store', err)
                this.$router.push('/login')
              })
              // this.$router.push({name: 'Join2CompleteApproved'})
            } else {
              this.$router.push({name: 'Join2CompleteUnapproved'})
            }
          } else if (this.join.socialLink.socialType === 'telegram') {

            this.$router.push({
              name: "TelegramMessageAuth",
              query: {
                memberId: responseData.id
              }
            });

          } else {
            this.$router.push({name: 'Join2CompleteUnapproved'})
          }
          this.$hideLoading();
        }).catch((err) => {
          this.$hideLoading();
          console.log(err.response)
          responseData = err.response.data.meta
          let errMsg = this.$t(`system.err.${responseData.errCode}`)
          this.$error({content: errMsg}).then(() => {
            this.$hideLoading();
            this.$router.push('/login')
          })
        })

      } else {
        this.$snackOpen({
          contents: this.$t('947'), //매장을 선택하세요.
          btnDisplay: ''
        }).then(() => {})
      }
    },

		setParams() {
            const params = {
                name: this.searchValue,
                page: this.currentPage,
                size: 10
            }
            return params
        },
		searchButton() {
			//this.fetchStore()
		},

		closeButton() {
			this.searchValue= ''
			this.selectedStore= '' 
			//this.fetchStore()
		}
	},
}
</script>
